const BookingSidebarBottomContent = () => {
  return <></>
}

export default BookingSidebarBottomContent
